import useSitecoreContext from './useSitecoreContext';

// returns true in Experience editor edit mode
// more reliable than isExperienceEditor function
export default function useEEActive(previewIncluded = false): boolean {
  const {sitecoreContext} = useSitecoreContext();
  let isEEActive = sitecoreContext?.pageEditing;
  if (previewIncluded) {
    isEEActive = isEEActive || sitecoreContext?.pageState === 'preview';
  }

  return !!isEEActive;
}
